var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"cn-header-menu"},[_vm._t("default",null,{"activeItem":_setup.activeItem,"setActiveItem":_setup.setActiveItem})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }